module.exports = __webpack_public_path__ + "media/images/talent/case4-icon02-ccec6677b49bc2bb90fbcbcde04cd351.png";